import { Carousel } from '@mantine/carousel';
import {
  ActionIcon,
  Box,
  Button,
  Container,
  Flex,
  Grid,
  HoverCard,
  Image,
  Menu,
  Modal,
  Paper,
  Rating,
  Text,
  createStyles,
  useMantineTheme,
  Select
} from '@mantine/core';
import {
  IconArrowsMaximize,
  IconHeart,
  IconMoneybag,
  IconPercentage,
  IconPlus,
  IconStar,
  IconStars,
  IconTrendingUp,
} from '@tabler/icons-react';
import { image_url, is_mobile_view } from '../config';
import { useNavigate } from 'react-router';
import { useMediaQuery } from '@mantine/hooks';
import { IconShoppingCart } from '@tabler/icons';
import { useRef, useMemo, useState, useEffect } from 'react';
import { priceCalculator } from '../utilities/Common';
import { api } from '../services/master.service';
import { showErrorToast, showSuccessToast } from '../utilities/Toast';

export default function ProductCard(props) {
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const theme = useMantineTheme();
  const navigate = useNavigate();

  const cartRef = useRef();

  const getInitialVariant = (product) => {
    if (
      product?.isVarient &&
      Array.isArray(product?.variants) &&
      product.variants.length > 0
    ) {
      const firstVariant = Number(product.variants[0]);
      return isNaN(firstVariant) ? 1 : firstVariant;
    }
    return 1;
  };

  const [selectedValue, setSelectedValue] = useState(() =>
    getInitialVariant(props?.object)
  );

  // useEffect - only update if the value actually changes
  useEffect(() => {
    const newValue = getInitialVariant(props?.object);
    setSelectedValue((prev) => (prev !== newValue ? newValue : prev));
  }, [props?.object]);

  const varients = useMemo(() => {
    const product = props?.object;
    if (
      product?.isVarient &&
      Array.isArray(product?.variants) &&
      product.variants.length > 0
    ) {
      const sortedData = [...product.variants].sort(
        (a, b) => Number(a) - Number(b)
      );

      return sortedData.map((value) => ({
        label: product.varientUnit == 'kg' && value < 1 ? `${value * 1000}${'g'}` : `${value}${product.varientUnit ?? ''}`,
        value: Number(value),
      }));
    }

    return [{ label: '1', value: 1 }];
  }, [props?.object]);

  const outOfStock = props?.object?.stock_qty <= props?.object?.min_qty || props?.object?.stock_qty <= 0 || !props?.object?.is_batch


  console.log('qqq-001-prod :', props)

  // const priceCalculator = (price, qty, unit) => {

  //   if (unit == 'g') {
  //     return (qty / 1000) * price
  //   } else {
  //     return qty * price
  //   }

  // }

  // console.log('qqq-123', props)

  return (
    <div>
      <Paper
        className="product-box"
        bg="white"
        p={isMobileScreen ? 10 : 24}
        shadow="sm"
        sx={{
          width: '100%',
          border: '2px solid transparent',
          cursor: 'pointer',
          transition: '.3s ease',
          borderRadius: 6,
          overflow: 'hidden',
          '&:hover': {
            border: `2px solid ${theme.colors.brand[5]}`,
            '& .product-actions': {
              visibility: 'visible',
              opacity: 1,
              right: 0,
              transform: 'none',
            },
          },
        }}
      >
        <Box
          className="product-box__top-area"
          pos={'relative'}
          onClick={() => {
            navigate('/product' + `/?id=${props.object.id}`);
          }}
        >
          <Image
            src={image_url + props.object.thumbnail}
            width={'100%'}
            mx={'auto'}
            mb={15}
            height={isMobileScreen ? 100 : 150}
            fit="contain"
            sx={{ borderRadius: 4 }}
          ></Image>
          {/* <Box pos={'absolute'} top={-10} right={-10}>
            <Flex
              justify={'center'}
              align={'center'}
              bg={theme.colors.brand[5]}
              w={35}
              h={35}
              sx={{
                borderRadius: 40,
              }}
            >
              <Text
                color="white"
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                }}
              >
                -15%
              </Text>
            </Flex>
          </Box> */}
        </Box>

        <Text size={'14px'} fw={'500'} mb={5} lineClamp={1}>
          {props.object.title}
        </Text>
        {isMobileScreen ? (
          <></>
        ) : (
          <div style={{ height: '20px' }}>
            {outOfStock ? (
              <Text size={'10px'} fw={'700'} mb={5} lineClamp={1} color="red">
                Out of Stock!
              </Text>
            ) : (
              <></>
            )
              // props.object.stock_qty > 3 ? (
              //   <></>
              // ) : (
              //   <Text size={'10px'} fw={'500'} mb={5} lineClamp={1} color="green">
              //     only {props.object.stock_qty} left Hurry!
              //   </Text>
              // )
              
            }
          </div>
        )}
        {isMobileScreen ? (
          <></>
        ) : (
          <Flex align={'top'}>
            <Rating readOnly mb={15} defaultValue={props.object.review} value={props.object.review} size="xs" />
            <Text ml={5} size={'11px'}>
              ( {props.object.review} )
            </Text>
          </Flex>
        )}

        <Flex align={'left'} mb={14}>
          <Select
            placeholder="varient"
            data={varients}
            size='xs'
            style={{ width: "40%" }}
            disabled={!props?.object?.isVarient}
            value={selectedValue}
            onChange={setSelectedValue}
          />
        </Flex>

        <Flex align={'center'} mb={15}>
          <Text strikethrough size={12} mr={10} color="#ff0000" opacity={0.7}>
            {/* ₹ {props.object.mrp * selectedValue} */}
            ₹ {priceCalculator(props.object.mrp, selectedValue, props?.object?.varientUnit, props?.object?.isVarient, 1)}
          </Text>
          <Text fw={500} size={16} width={'100%'}>
            {/* ₹ {props.object.price * selectedValue} */}
            ₹ {priceCalculator(props.object.price, selectedValue, props?.object?.varientUnit, props?.object?.isVarient, 1)}
          </Text>
        </Flex>
        {/* <Button
          disabled={outOfStock}
          variant={isMobileScreen ? 'light' : 'filled'}
          radius={50}
          ref={cartRef}
          size="xs"
          w={'100%'}
          //style={{ border: '1px solid green' }}
          onMouseLeave={() => {
            cartRef.current.style.border = 'none';
          }}
          onClick={() => {
            props.addToCart(props.object.id, selectedValue, props?.object?.varientUnit, props?.object?.isVarient);
            if (isMobileScreen) {
              cartRef.current.style.border = '1px solid lightgreen';
            }
          }}
        >
          <IconPlus style={{ width: 14, marginRight: 8 }} /> Add To Cart
        </Button> */}
<div
  style={{
    display: "flex",
    flexDirection: isMobileScreen ? "column" : "row",
    gap: "10px",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  {props.object.stock_qty > props.object.min_qty && (
  <Button
    disabled={props.object.stock_qty <= props.object.min_qty}
    variant={isMobileScreen ? "light" : "filled"}
    radius={50}
    ref={cartRef}
    size="xs"
    style={{ flex: 1, minWidth: "120px" }}
    onMouseLeave={() => {
      cartRef.current.style.border = "none";
    }}
    onClick={() => {
      props.addToCart(
        props.object.id,
        selectedValue,
        props?.object?.varientUnit,
        props?.object?.isVarient
      );
      if (isMobileScreen) {
        cartRef.current.style.border = "1px solid lightgreen";
      }
    }}
  >
    <IconPlus style={{ width: 14, marginRight: 8 }} /> Add To Cart
  </Button>
)}
  {props.object.stock_qty <= props.object.min_qty && (
    <Button
      variant={isMobileScreen ? "light" : "filled"}
      radius={50}
      size="xs"
      style={{ flex: 1, minWidth: "120px", backgroundColor: isMobileScreen ? 'rgb(255 253 203)' : '#f97316', // ✅ orange color
        color: isMobileScreen ? '#f97316' : 'white', transition: 'background-color 0.3s ease', }}
      onMouseLeave={() => {
        cartRef.current.style.border = "none";
      }}
       onClick={async () => {
       const res = await api.notify_me({
         product_id: props.object.id,
         status: "Notified",
         add_cart: false,
       });
       console.log(res, 'notifymeeeee');     

       if (res.success) {
         showSuccessToast({
           title: "Success",
           message: "You will be notified when product is back in stock.",
         });
       } else {
         // ✅ Special case: already notified
         if (res.message === "You have already been notified for this product.") {
           showErrorToast({
             title: "Already Notified",
             message: "You are already subscribed for notifications on this product.",
           });
         } else {
           showErrorToast({
             title: "Error",
             message: res.message || "Failed to save notification request.",
           });
         }
       }
     }}
    >
     <IconPlus style={{ width: 14, marginRight: 8 }} /> Notify Me
    </Button>
    )}
</div>

      </Paper>
    </div>
  );
}
